import React, { useEffect, useState } from "react";
import { ProductServices } from "../../../core/services/ProductServices";
import { Button, SelectPicker, CheckPicker, Loader } from "rsuite";
import { Form, Field } from "react-final-form";
import ImageIcon from "@rsuite/icons/Image";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { Link, useNavigate } from "react-router-dom";
import useDecryptedParams from "../../../navigation/useDecryptParams";
import { useParams } from "react-router-dom";
import "./Product.css";
import { useTranslation } from "react-i18next";
import { CKEditor } from "ckeditor4-react";
import { ContentRoutes } from "../../../navigation/NavConstant";
import { messageTypeArr } from "../../../core/config/AppConstants";
import { isEmptyVal, isNotNull } from "../../../utils/helpers";

const ProductStepTwo = ({
  fieldsInfo,
  productType,
  setStep,
  step,
}: {
  fieldsInfo: any;
  productType: any;
  setStep: Function;
  step: number;
}) => {
  const { t } = useTranslation();
  const [btnLoading, setBtnLoading] = useState(false);
  const [stepTwoFields, setSetpTwoFields] = useState<any>([]);
  const [productImage, setProductImage] = useState<any>(null);
  const [productImageURL, setProductImageURL] = useState<any>(null);
  const [isProdImgValid, setIsProdImageValid] = useState("");
  const [prodCategories, setProdCategories] = useState<any>([]);
  const [loader, setLoading] = useState(false);
  const [selectedProdType, setSelectedProdType] = useState<any>("");
  const navigate = useNavigate();
  const [stepTwoInitialVal, setStepTwoInitialVal] = useState<any>({});
  const params = useParams();
  let [decryptedParams] = useDecryptedParams(params);

  useEffect(() => {
    let allFields;
    if (fieldsInfo && fieldsInfo?.length) {
      allFields = fieldsInfo.slice(1, fieldsInfo?.length);
      //extractng form keys dynamically
      if (decryptedParams && decryptedParams.id) {
        viewProduct(+decryptedParams.id, fieldsInfo);
      }
    }

    setSetpTwoFields(allFields);
  }, [fieldsInfo]);

  useEffect(() => {
    if (step === 2 && productType) {
      getProductCategories(+productType);
    }
  }, [step]);

  const viewProduct = async (productId: number, fieldsInfo: any) => {
    try {
      setLoading(true);
      const res: any = await ProductServices.viewProduct(productId);
      let formObj: any = {};
      fieldsInfo.map((item: any) => {
        if (item?.field_name === "status") {
          formObj[item.field_name] = "" + res?.data?.data[item.field_name] + "";
        }
        if (
          item?.field_name === "product_image" &&
          res?.data?.data["image_url"]
        ) {
          setProductImage(res?.data?.data["image_url"]);
        }
        if (
          item?.field_name &&
          item?.field_name !== "product_image" &&
          item?.field_name !== "status"
        ) {
          formObj[item.field_name] = res?.data?.data[item.field_name];
        }
      });
      setStepTwoInitialVal({ ...formObj });
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
    }
  };

  const getProductCategories = async (productType: number) => {
    try {
      const res = await ProductServices.getProductCategories(+productType);
      setProdCategories(res?.data?.data);
    } catch (error: any) {
      console.log(error);
    }
  };

  const handleFinalFormSubmit = (val: any) => {
    let formSubmit = new FormData();
    Object.keys(val).map((field: any) => {
      if (isNotNull(val[field])) formSubmit.append(field, val[field]);
    });
    if (typeof productImage === "object" && productImage) {
      formSubmit.append("product_image", productImage);
    } else {
      formSubmit.delete("product_image");
    }
    formSubmit.append("product_type_id", productType);
    if (decryptedParams?.id) {
      saveProduct(formSubmit, +decryptedParams?.id);
    } else {
      saveProduct(formSubmit);
    }
  };

  const saveProduct = async (form: any, id?: number) => {
    try {
      setLoading(true);
      setBtnLoading(true);
      let response: any;
      if (id) {
        response = await ProductServices.updateProduct(+id, form);
      } else {
        response = await ProductServices.createProduct(form);
      }
      setLoading(false);
      setBtnLoading(false);
      UtilityServices.showToaster({
        message: response?.data?.message,
      });
      navigate(ContentRoutes.PRODUCTS);
    } catch (error: any) {
      setLoading(false);
      setBtnLoading(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
    }
  };

  const createProduct = async (formData: any) => {
    try {
      const res = await ProductServices.createProduct(formData);
      UtilityServices.showToaster({
        message: res?.data?.message,
        type: "success",
      });
      navigate(ContentRoutes.PRODUCTS);
    } catch (error: any) {
      UtilityServices.showToaster({ message: error?.message, type: "error" });
    }
  };

  return (
    <div>
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Form
        onSubmit={handleFinalFormSubmit}
        initialValues={{ ...stepTwoInitialVal }}
        render={({ handleSubmit, form }) => (
          <form onSubmit={handleSubmit} className="product-form">
            <div className="product-pnl">
              {stepTwoFields &&
                stepTwoFields.length &&
                stepTwoFields.map((fieldInfo: any, index: number) => {
                  return (
                    <div className={fieldInfo?.css_class} key={index}>
                      <Field
                        name={fieldInfo?.field_name}
                        validate={(v: any) => {
                          if (!v && fieldInfo?.validations?.valid_status) {
                            return `${fieldInfo.messages.valid_status}`;
                          }
                          if (!v && fieldInfo?.validations?.required) {
                            return `${fieldInfo.messages.required}`;
                          }
                          if (
                            v &&
                            fieldInfo?.validations?.maxLength < v.length
                          ) {
                            return `${fieldInfo.messages.maxLength}`;
                          }
                          if (
                            v &&
                            fieldInfo?.validations?.minLength > v.length
                          ) {
                            return `${fieldInfo.messages.minLength}`;
                          }
                          if (v && fieldInfo?.validations?.valid_decimal) {
                            if (!/^\d+(\.\d{1,2})?$/.test(v)) {
                              return fieldInfo?.messages?.valid_decimal;
                            }
                          }
                          if (
                            v &&
                            fieldInfo?.validations?.numeric &&
                            !!fieldInfo?.validations?.min_val &&
                            !!fieldInfo?.validations?.max_val
                          ) {
                            if (+v < +fieldInfo?.validations?.min_val) {
                              return fieldInfo?.messages?.min_val;
                            }
                            if (+v > +fieldInfo?.validations?.max_val) {
                              return fieldInfo?.messages?.max_val;
                            }
                            if (+v % 1 !== 0) {
                              return fieldInfo?.messages?.numeric;
                            }
                          }
                          if (
                            v &&
                            !!fieldInfo?.validations?.min_val &&
                            fieldInfo?.validations?.numeric
                          ) {
                            if (fieldInfo?.validations?.numeric) {
                              if (+v % 1 !== 0) {
                                return fieldInfo?.messages?.numeric;
                              }
                            }
                            if (
                              +v < +fieldInfo?.validations?.min_val ||
                              +v < 0
                            ) {
                              return fieldInfo?.messages?.min_val;
                            }
                          }
                          if (
                            v &&
                            !!fieldInfo?.validations?.max_val &&
                            fieldInfo?.validations?.numeric
                          ) {
                            if (fieldInfo?.validations?.numeric) {
                              if (+v % 1 !== 0) {
                                return fieldInfo?.messages?.numeric;
                              }
                            } else {
                              return +v > +fieldInfo?.validations?.max_val
                                ? fieldInfo?.messages?.max_val
                                : null;
                            }
                          }
                          if (v && fieldInfo?.validations?.valid_url) {
                            let validUrlRegex =
                              /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%.\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%\+.~#?&//=]*)/g;
                            if (!validUrlRegex.test(v)) {
                              return fieldInfo?.messages?.valid_url;
                            }
                          }
                        }}
                      >
                        {({ input, meta }) => (
                          <div
                            className={
                              fieldInfo?.field_type === "editor" &&
                              fieldInfo.field_name === "product_detail"
                                ? ""
                                : "flex-item"
                            }
                          >
                            {fieldInfo?.field_name !== "available_on_day" &&
                            fieldInfo?.field_name !== "product_image" &&
                            fieldInfo?.field_name !== "status" ? (
                              <>
                                <label>{fieldInfo?.label}</label>
                                {fieldInfo?.field_type === "text" ? (
                                  <input
                                    {...input}
                                    placeholder={fieldInfo?.placeholder}
                                    type={fieldInfo?.field_type}
                                  />
                                ) : null}
                                {fieldInfo?.field_type === "textarea" &&
                                fieldInfo.field_name !== "product_detail" ? (
                                  <textarea
                                    rows={5}
                                    cols={50}
                                    {...input}
                                    placeholder={fieldInfo?.placeholder}
                                  ></textarea>
                                ) : null}
                                {fieldInfo?.field_type === "editor" &&
                                fieldInfo.field_name === "product_detail" ? (
                                  <div className="editor-style">
                                    {decryptedParams?.id && input.value ? (
                                      <CKEditor
                                        initData={input.value}
                                        onChange={(event: any) => {
                                          if (
                                            event?.sender?.document?.$?.body
                                              ?.innerHTML
                                          ) {
                                            form.change(
                                              "product_detail",
                                              event.sender.document.$.body
                                                .innerHTML,
                                            );
                                          }
                                        }}
                                        style={{ borderColor: "blue" }}
                                        type="classic"
                                      />
                                    ) : null}

                                    {!decryptedParams?.id ? (
                                      <CKEditor
                                        initData={input.value}
                                        onChange={(event: any) => {
                                          if (
                                            event?.sender?.document?.$?.body
                                              ?.innerHTML
                                          ) {
                                            form.change(
                                              "product_detail",
                                              event.sender.document.$.body
                                                .innerHTML,
                                            );
                                          }
                                        }}
                                        style={{ borderColor: "blue" }}
                                        type="classic"
                                      />
                                    ) : null}
                                  </div>
                                ) : null}
                                {fieldInfo?.field_type === "dropdown" &&
                                fieldInfo?.field_name ===
                                  "product_category_id" ? (
                                  <SelectPicker
                                    searchable={false}
                                    onSelect={(e: any) => {
                                      form.change(fieldInfo?.field_name, e);
                                    }}
                                    onClean={() => {
                                      form.change(fieldInfo?.field_name, "");
                                    }}
                                    valueKey="id"
                                    labelKey="cat_name"
                                    data={prodCategories}
                                    value={input.value}
                                  />
                                ) : null}
                                {fieldInfo?.field_type === "dropdown" &&
                                fieldInfo?.field_name === "size" ? (
                                  <SelectPicker
                                    searchable={false}
                                    onSelect={(e: any) => {
                                      form.change(fieldInfo?.field_name, e);
                                    }}
                                    onClean={() => {
                                      form.change(fieldInfo?.field_name, "");
                                    }}
                                    valueKey="show_size"
                                    labelKey="label"
                                    data={fieldInfo?.field_options_value}
                                    value={input?.value}
                                  />
                                ) : null}
                                {fieldInfo?.field_type === "dropdown" &&
                                fieldInfo?.field_name === "food_type" ? (
                                  <SelectPicker
                                    searchable={false}
                                    onSelect={(e: any) => {
                                      form.change(fieldInfo?.field_name, e);
                                    }}
                                    onClean={() => {
                                      form.change(fieldInfo?.field_name, "");
                                    }}
                                    valueKey="value"
                                    labelKey="label"
                                    data={fieldInfo?.field_options_value}
                                    value={input?.value}
                                  />
                                ) : null}

                                {fieldInfo?.field_type === "dropdown" &&
                                fieldInfo?.field_name === "product_nature" ? (
                                  <SelectPicker
                                    searchable={false}
                                    onSelect={(e: any) => {
                                      form.change(fieldInfo?.field_name, e);
                                    }}
                                    onClean={() => {
                                      form.change(fieldInfo?.field_name, "");
                                    }}
                                    valueKey="value"
                                    labelKey="label"
                                    data={fieldInfo?.field_options_value}
                                    value={input?.value}
                                  />
                                ) : null}

                                {fieldInfo?.field_type === "dropdown" &&
                                fieldInfo?.field_name ===
                                  "product_for_gender" ? (
                                  <SelectPicker
                                    searchable={false}
                                    onSelect={(e: any) => {
                                      form.change(fieldInfo?.field_name, e);
                                    }}
                                    onClean={() => {
                                      form.change(fieldInfo?.field_name, "");
                                    }}
                                    valueKey="value"
                                    labelKey="label"
                                    data={fieldInfo?.field_options_value}
                                    value={input?.value}
                                  />
                                ) : null}
                              </>
                            ) : null}

                            {fieldInfo?.field_name === "product_image" ? (
                              <>
                                <label>{fieldInfo?.label}</label>
                                <div
                                  style={{
                                    width: "100%",
                                    border: "1px solid #575757",
                                    borderRadius: "5px",
                                    minHeight: "180px",
                                    maxHeight: "250px",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "10px",
                                    overflow: "hidden",
                                  }}
                                >
                                  {productImage && (
                                    <img
                                      src={
                                        typeof productImage == "object"
                                          ? productImageURL
                                          : productImage
                                      }
                                      alt="upload image"
                                      style={{
                                        maxWidth: "100%",
                                        maxHeight: "180px",
                                        objectFit: "contain",
                                        marginBottom: "10px",
                                      }}
                                    />
                                  )}
                                  <label
                                    htmlFor="product_image"
                                    style={{
                                      cursor: "pointer",
                                      fontWeight: 500,
                                    }}
                                  >
                                    {!productImage && (
                                      <>
                                        <ImageIcon
                                          style={{ fontSize: "80px" }}
                                        />
                                        <br />
                                      </>
                                    )}
                                    Upload {productImage ? "New " : "Product "}
                                    Image
                                  </label>
                                </div>
                                <input
                                  id="product_image"
                                  {...input}
                                  type={fieldInfo?.field_type}
                                  accept="image/png, image/gif, image/jpeg"
                                  hidden
                                  onInput={(e: any) => {
                                    let file = e.target.files[0];
                                    let fileSize = Math.ceil(
                                      file.size / 1024 / 1024,
                                    );
                                    let allowedSize =
                                      +fieldInfo.validations?.max_file_size;
                                    let fileType = file.name.split(".");
                                    let fileExt = fileType[fileType.length - 1];
                                    if (file && fileSize <= allowedSize) {
                                      if (
                                        fileExt === "jpg" ||
                                        fileExt === "jpeg" ||
                                        fileExt === "png" ||
                                        fileExt === "gif"
                                      ) {
                                        setProductImage(file);
                                        setProductImageURL(
                                          URL.createObjectURL(file),
                                        );
                                        setIsProdImageValid("");
                                      } else {
                                        setIsProdImageValid(
                                          fieldInfo.messages?.valid_image,
                                        );
                                      }
                                    } else {
                                      setIsProdImageValid(
                                        fieldInfo.messages?.max_file_size,
                                      );
                                      setProductImage(null);
                                      setProductImageURL(null);
                                    }
                                  }}
                                />
                                {!!isProdImgValid ? (
                                  <span>{isProdImgValid}</span>
                                ) : null}
                              </>
                            ) : null}

                            {fieldInfo?.field_name === "available_on_day" ? (
                              <div>
                                <label>{fieldInfo?.label}</label>
                                <CheckPicker
                                  sticky
                                  name={fieldInfo?.field_name}
                                  onChange={(e: any) => {
                                    if (e.length === 1) {
                                      form.change(
                                        fieldInfo?.field_name,
                                        e[0]?.toString(),
                                      );
                                    } else if (e.length > 1) {
                                      if (!e.includes("8")) {
                                        form.change(
                                          fieldInfo?.field_name,
                                          e?.toString(),
                                        );
                                      } else {
                                        form.change(
                                          fieldInfo?.field_name,
                                          "8,7,6,5,4,3,2,1",
                                        );
                                      }
                                    }
                                  }}
                                  onClean={() => {
                                    form.change(fieldInfo?.field_name, "");
                                  }}
                                  data={fieldInfo?.field_options_value}
                                  value={
                                    input?.value === "8"
                                      ? ["8", "7", "6", "5", "4", "3", "2", "1"]
                                      : input?.value?.split(",")
                                  }
                                />
                              </div>
                            ) : null}

                            {fieldInfo?.field_name === "status" ? (
                              <div>
                                <label>{fieldInfo?.label}</label>
                                <div
                                  className="radio-fields"
                                  style={{
                                    display: "inline-block",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <Field
                                    style={{
                                      display: "inline !important",
                                      width: "15px",
                                      height: "15px",
                                      marginRight: "5px",
                                    }}
                                    name={fieldInfo?.field_name}
                                    type={fieldInfo?.field_type}
                                    value="1"
                                    initialValue={stepTwoInitialVal?.status?.toString()}
                                    component="input"
                                  />
                                  <label style={{ display: "inline-block" }}>
                                    {t("ACTIVE")}
                                  </label>
                                </div>

                                <div
                                  className="radio-fields"
                                  style={{
                                    display: "inline-block",
                                    marginLeft: "15px",
                                  }}
                                >
                                  <Field
                                    style={{
                                      display: "inline-block !important",
                                      width: "15px",
                                      height: "15px",
                                      marginRight: "5px",
                                    }}
                                    name={fieldInfo?.field_name}
                                    type={fieldInfo?.field_type}
                                    value="0"
                                    initialValue={stepTwoInitialVal?.status?.toString()}
                                    component="input"
                                  />
                                  <label style={{ display: "inline-block" }}>
                                    {t("INACTIVE")}
                                  </label>
                                </div>
                              </div>
                            ) : null}
                            {meta.error && meta.touched && (
                              <span style={{ color: "red" }}>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                    </div>
                  );
                })}
            </div>
            <div className="text-center mt-3">
              {step === 2 && (
                <>
                  <Button
                    appearance="primary"
                    color="green"
                    type="submit"
                    loading={btnLoading}
                  >
                    {decryptedParams?.id ? t("UPDATE") : t("CREATE")}
                  </Button>{" "}
                  <Link to={ContentRoutes.PRODUCTS}>
                    <Button appearance="primary" color="blue" type="button">
                      {t("BACK")} {t("TO").toLocaleLowerCase()}{" "}
                      {t("LIST").toLocaleLowerCase()}
                    </Button>
                  </Link>
                </>
              )}
            </div>
          </form>
        )}
      />
    </div>
  );
};

export default ProductStepTwo;
